import React, { useState } from 'react';
import { Clock, User, ArrowRight } from 'lucide-react';

const PostCard = ({ post }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  // Default post data if not provided
  const defaultPost = {
    title: "Modern Post Card Design",
    excerpt: "This is a modern post card with hover animations and clean design",
    author: "John Doe",
    date: "May 4, 2025",
    slug: "modern-post-card",
    ...post
  };
  
  return (
    <div 
      className={`bg-white dark:bg-gray-900 rounded-2xl overflow-hidden shadow-lg transition-all duration-300 border border-gray-100 dark:border-gray-800 ${isHovered ? 'shadow-xl translate-y-[-4px]' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {defaultPost.image && (
        <div className="w-full h-48 overflow-hidden">
          <img 
            src="/api/placeholder/800/400" 
            alt={defaultPost.title}
            className="w-full h-full object-cover transition-transform duration-300 ease-in-out"
            style={{
              transform: isHovered ? 'scale(1.05)' : 'scale(1)'
            }}
          />
        </div>
      )}
      
      <div className="p-6">
        {/* Category tag if available */}
        {defaultPost.category && (
          <div className="mb-3">
            <span className="px-3 py-1 text-xs font-medium bg-indigo-100 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-300 rounded-full">
              {defaultPost.category}
            </span>
          </div>
        )}
        
        <h2 className="text-2xl font-bold mb-3 text-gray-800 dark:text-white transition-colors duration-300">
          {defaultPost.title}
        </h2>
        
        <p className="text-gray-600 dark:text-gray-300 mb-4 line-clamp-2">
          {defaultPost.excerpt}
        </p>
        
        <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-4 space-x-4">
          {defaultPost.author && (
            <div className="flex items-center">
              <User size={16} className="mr-1" />
              <span>{defaultPost.author}</span>
            </div>
          )}
          
          {defaultPost.date && (
            <div className="flex items-center">
              <Clock size={16} className="mr-1" />
              <span>{defaultPost.date}</span>
            </div>
          )}
        </div>
        
        <a
          href={`/blog/${defaultPost.slug}`}
          className="inline-flex items-center text-indigo-600 dark:text-indigo-400 font-medium group"
        >
          <span className="relative">
            Read More
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-indigo-600 dark:bg-indigo-400 transition-all duration-300 group-hover:w-full"></span>
          </span>
          <ArrowRight 
            size={18} 
            className="ml-1 transition-transform duration-300 group-hover:translate-x-1" 
          />
        </a>
      </div>
    </div>
  );
};

export default PostCard;